export default "__VITE_ASSET__B6yUFuCC__"